import { Tab, Tabs } from '@mui/material';

import { withStyles } from 'tss-react/mui';

import type { ComponentProps } from 'react';

export type ProfileTabProps = Pick<ComponentProps<typeof Tab>, 'value' | 'label' | 'title' | 'disabled'>;

export type ProfileTabsProps = {
  className?: string;
  tab: string;
  tabs: ProfileTabProps[];
  onChange: (tab: string) => void;
};

export const ProfileTabs: React.VFC<ProfileTabsProps> = ({ className, tab, tabs, onChange }) => {
  return (
    <Tabs
      className={className}
      value={tabs.some(t => t.value === tab) ? tab : false}
      onChange={(_e, value) => onChange(value)}
      textColor="secondary"
      indicatorColor="secondary"
    >
      {tabs.map(params => {
        return (
          <CustomTab key={params.value} {...params} data-testid={`${params.value}-tab`} />
        );
      })}
    </Tabs>
  );
};

const CustomTab = withStyles(Tab, theme => ({
  root: {
    minWidth: 'auto',
    padding: theme.spacing(1, 4),
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.5px',
    textTransform: 'none',
  },
}));
